export enum SharedPoolStatus {
  INITIATED = "INITIATED",
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}
